import type { ProjectFunction, UnprojectFunction } from '../types'
import { Event } from '../types'
import { EventBus } from '../core/event-bus'
import * as L from 'leaflet'
import * as PIXI from 'pixi.js'
import 'leaflet-pixi-overlay'

export class OverlayRenderer {
  private readonly container: PIXI.Container
  private readonly pixiOverlay: any
  private renderer: PIXI.Renderer
  public project: ProjectFunction
  private unproject: UnprojectFunction
  private readonly eventBus: EventBus = EventBus.getInstance()

  constructor (map: L.Map) {
    PIXI.Graphics.curves.adaptive = false

    this.container = new PIXI.Container()
    this.pixiOverlay = L.pixiOverlay((utils) => {
      this.renderer = utils.getRenderer()
      this.project = utils.latLngToLayerPoint
      this.unproject = utils.layerPointToLatLng
      this.renderer.render(this.container)
    }, this.container)

    this.pixiOverlay.addTo(map)

    this.eventBus.subscribe(Event.REDRAW, () => this.redraw())
  }

  public redraw (): void {
    if (this.pixiOverlay != null) {
      this.pixiOverlay.redraw()
    }
  }

  public getContainer (): PIXI.Container {
    return this.container
  }

  public addGraphics (graphics: PIXI.Graphics[]): void {
    graphics.forEach(graphic => {
      this.container.addChild(graphic)
    })
  }
}
